import ViewOnly from '../ViewOnly';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import DeleteIcon from '@material-ui/icons/Delete';
import PropTypes from 'prop-types';
import React from 'react';
import GroupSelector from '../GroupSelector';
import AreYouSure from '../AreYouSure';
import { globalStyles as styles } from '../style/gstheme';
import TitledPanel from '../TitledPanel';
import BasicReadField from '../BasicReadField';
import { ENTITLEMENTS } from '../utils/constants';
import { checkResourceEntitlements } from '../utils/utils';
import withGS from '../withGShoc';
import UserAvatar from './UserAvatar';

class UserDetail extends React.Component {

    state = {
        areYouSure: false
    };

    checkIfSure = () => this.setState({ areYouSure: true });

    onSure = () => {
        this.setState({ areYouSure: false });
        this.props.onDeleteUser(this.props.data.id);
    };

    onNotSure = () => this.setState({ areYouSure: false });

    onUpdate = (property) => (value) => this.props.onUpdate(property, value);

    handleToggle = (groupIRI) => {
        const { isMemberOfGroup } = this.props.data;
        const currentIndex = isMemberOfGroup ? isMemberOfGroup.indexOf(groupIRI) : -1;
        currentIndex === -1 ? this.props.onAdd('isMemberOfGroup', groupIRI) : this.props.onDelete('isMemberOfGroup', groupIRI);
    };

    render() {

        const { data, classes, user, withDrawn, readOnly } = this.props;
        const { username } = user;
        const { areYouSure } = this.state;
        const { isMemberOfGroup, id } = data;
        const isReadOnly = readOnly || checkResourceEntitlements(data, [ENTITLEMENTS.EDIT_USER]);
        const fn = user.familyName || "";
        const gn = user.givenName || "";
        const nameTitle = user.familyName || user.givenName ? [gn, fn].join(" ") : "No name given";

        return (
            <form autoComplete="off">
                <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: '13px' }}>
                    <div style={{ display: 'flex' }}>
                        <UserAvatar givenName={gn} familyName={fn} />
                        <Typography style={{ marginLeft: '10px', marginTop: '3px' }} className={classes.mainHeading}>{nameTitle}{isReadOnly && <ViewOnly />}</Typography>
                    </div>
                    {!isReadOnly && !withDrawn &&
                        <Tooltip title='Remove user from subscription' style={{ alignSelf: 'flex-end', marginTop: '5px', marginRight: 20 }}>
                            <IconButton aria-label="Remove user" data-test="remove-user" size="small" onClick={this.checkIfSure} className={classes.deleteButton}>
                                <DeleteIcon />
                            </IconButton>
                        </Tooltip>
                    }
                </div>
                <Grid data-test="user-details" container spacing={2} style={{ marginBottom: 5 }}>
                    <Grid item xs={12} md={4}>
                        <TitledPanel height="full" title="Username">
                            <BasicReadField ariaLabel="Username" dataTest="username" fullWidth text={username} locked />
                        </TitledPanel>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <TitledPanel title="Given Name" height="full">
                            <BasicReadField ariaLabel="Given name" dataTest="givenName" fullWidth text={gn} locked />
                        </TitledPanel>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <TitledPanel title="Family Name" height="full">
                            <BasicReadField ariaLabel="Family name" dataTest="familyName" fullWidth text={fn} locked />
                        </TitledPanel>
                    </Grid>
                    <Grid item xs={12}>
                        <TitledPanel height="full" title="IRI">
                            <BasicReadField ariaLabel="User IRI" dataTest="iri" fullWidth text={id} locked />
                        </TitledPanel>
                    </Grid>
                </Grid>
                <GroupSelector
                    isReadOnly={isReadOnly || withDrawn}
                    groupList={isMemberOfGroup ? isMemberOfGroup : []} handleToggle={this.handleToggle} />
                {areYouSure && <AreYouSure onSure={this.onSure} onNotSure={this.onNotSure} message="Do you really want to remove this user?" />}
            </form >
        );
    }
}

UserDetail.defaultProps = {
    readOnly: false
};

UserDetail.propTypes = {
    classes: PropTypes.object,
    onDeleteUser: PropTypes.func.isRequired,
    id: PropTypes.string.isRequired,
    onUpdate: PropTypes.func.isRequired,
    onAdd: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
    invitation: PropTypes.object.isRequired,
    withDrawn: PropTypes.bool.isRequired,
    data: PropTypes.object.isRequired,
    user: PropTypes.object,
    readOnly: PropTypes.bool,
    graph: PropTypes.string.isRequired
};

export default withStyles(styles)(withGS(UserDetail));